import React, { Component } from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import { GBGProductQualityCheckItem } from 'dashboard/GBG_products/components/GBGProductQualityCheckItem';

export const GBGProductQualityCheckList = SortableContainer(({ props }) => {
  const firstBaseQualityCheckIndex = props.currentRecord.matchingQualityChecks.findIndex(
    (item) => item.qualityCheckType == 'Base'
  );
  return (
    <div>
      {props.currentRecord.matchingQualityChecks.map((item, index) => {
        let baseQualityCheck = false;
        if (firstBaseQualityCheckIndex !== -1) {
          if (firstBaseQualityCheckIndex == index) {
            baseQualityCheck = true;
          }
        }

        return (
          <GBGProductQualityCheckItem
            key={`item-${index}`}
            props={props}
            baseQualityCheck={baseQualityCheck}
            index={index}
            itemIndex={index}
            item={item}
          />
        );
      })}
    </div>
  );
});
